import {Action} from '@ngrx/store';
import {type} from '../../shared';

export const cancelOrdersActionTypes = {
  CANCEL: type('[Cancel orders] CANCEL'),
  CANCEL_SUCCESS: type('[Cancel orders] CANCEL Success'),
  CANCEL_FAIL: type('[Cancel orders] CANCEL Fail')
};

export class CancelOrdersAction implements Action {
  readonly type = cancelOrdersActionTypes.CANCEL;
  constructor(public payload?: {'orderUuids': string[]}) {}
}

export class CancelOrdersSuccessAction implements Action {
  readonly type = cancelOrdersActionTypes.CANCEL_SUCCESS;
  constructor(public payload?: string[] ) {}
}

export class CancelOrdersFailAction implements Action {
  readonly type = cancelOrdersActionTypes.CANCEL_FAIL;
  constructor(public payload?: string) {}
}
